<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="block relative w-full mt-2">
      <div class="body_inners pl-4 pr-4">
        <div class="block top-block mb-4">
          <h2
            class="
              block
              text-darkgreen text-sm
              font-bold
              m-0
              title-block
              text-center
            "
          >
            {{ $t("pages.current_family.title") }}
          </h2>
          <p
            class="
              block
              text-lightGrey text-sm
              font-bold
              mt-1
              mb-0
              title-block
              text-center
            "
          >
            {{ $t("pages.current_family.sub_heading") }}
          </p>
        </div>

        <div
          class="list-items block relative"
          @click="
            $router.push({
              name: 'offerDetails',
              params: { id: details.offer.offer_id },
            })
          "
        >
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
          >
            <div class="flex top-block mb-3 pt-4 pb-1 pl-4 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  {{ details.offer.customer.last_name }}/{{
                    details.offer.customer.first_name
                  }}
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mb-0
                    mt-1.5
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3 h-3"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  {{ details.offer.location }}
                </p>
              </div>
              <div class="right-block w-2/4 relative">
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ formatPrice(details.offer.compensation) }} Euro
                </p>
                <p
                  class="
                    flex
                    align-center
                    justify-end
                    mt-1.5
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  {{ $t("pages.common.buttons.dis15") }}:
                  {{
                    formatDate(
                      details.offer.arrival_date,
                      "DD.MM.YYYY",
                      "YYYY-MM-DD"
                    )
                  }}
                </p>
              </div>
            </div>
            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgreen
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9464 1.14028C10.8847 1.07847 10.8115 1.02944 10.7308 0.995987C10.6502 0.962533 10.5637 0.945312 10.4764 0.945312C10.3891 0.945313 10.3026 0.962533 10.222 0.995987C10.1413 1.02944 10.0681 1.07847 10.0064 1.14028L4.35308 6.80028L1.99308 4.44028C1.86843 4.31562 1.69936 4.24559 1.52308 4.24559C1.34679 4.24559 1.17773 4.31562 1.05308 4.44028C0.928427 4.56493 0.858398 4.73399 0.858398 4.91028C0.858398 4.99756 0.875591 5.08399 0.908994 5.16464C0.942397 5.24528 0.991357 5.31855 1.05308 5.38028L3.87975 8.20694C4.13975 8.46694 4.55975 8.46694 4.81975 8.20694L10.9464 2.08028C11.2131 1.82028 11.2131 1.40028 10.9464 1.14028ZM1.99975 11.3336H9.99975C10.3664 11.3336 10.6664 11.0336 10.6664 10.6669C10.6664 10.3003 10.3664 10.0003 9.99975 10.0003H1.99975C1.63308 10.0003 1.33308 10.3003 1.33308 10.6669C1.33308 11.0336 1.63308 11.3336 1.99975 11.3336Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-medium">
                {{ $t("pages.common.buttons.dis123") }}
              </span>
            </div>
          </div>
        </div>

        <div class="relative block accordian-list-block">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
              tab
            "
          >
            <div class="card tab">
              <input
                id="tab-single1"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs1"
                checked
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  mb-0
                  pt-3
                  pb-3
                  pl-4
                  pr-4
                  top-block
                  bg-darkgreen
                  rounded-t-lg
                  tab
                  w-full
                "
                for="tab-single1"
              >
                <span
                  class="block relative text-sm font-bold capitalize text-white"
                >
                  {{ $t("pages.common.buttons.dis114") }}
                </span>
                <span class="flex transform rotate-180 duration-100">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 16 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </label>
              <div class="tab-content overflow-hidden card-body">
                <div class="block relative pl-4 pr-4 pt-2 pb-5">
                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-semibold
                      mb-1
                    "
                  >
                  
                    {{ $t("pages.common.buttons.dis115") }}
                  </label>

                   <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-2
                      text-darkgray1
                    "

                  >
                        {{ currentDate }} 

                  </label>
               
                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-2
                      text-darkgray1
                    "
                    v-if=" details.arrival_information.wishes"
                  >
                    {{ details.arrival_information.wishes }}
                  </label>

                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-semibold
                      mb-1
                    "
                  >
                    {{ $t("pages.common.buttons.dis200") }}
                  </label>
                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-1
                      text-darkgray1
                    "
                  >
                    {{ details.arrival_information.customer_name }}
                  </label>
                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-1
                    "
                  >
                    {{ details.arrival_information.street }},
                  </label>
                  <label
                    class="
                      block
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-0
                      text-darkgray1
                    "
                  >
                    {{ details.arrival_information.zip }}, {{ details.arrival_information.location }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relative block accordian-list-block">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
              tab
            "
          >
            <div class="card tab">
              <input
                id="tab-single2"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs2"
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  mb-0
                  pt-3
                  pb-3
                  pl-4
                  pr-4
                  top-block
                  bg-darkgreen
                  rounded-t-lg
                  tab
                  w-full
                "
                for="tab-single2"
              >
                <span
                  class="block relative text-sm font-bold capitalize text-white"
                >
                  {{ $t("pages.common.buttons.dis113") }}
                </span>
                <span class="flex transform rotate-180 duration-100">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 16 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </label>
              <div class="tab-content overflow-hidden card-body">
                <div class="block relative pl-4 pr-4 pt-2 pb-5">
                 
                  <label
                    class="
                      flex
                      items-center
                      justify-start
                      text-sm text-darkblack
                      capitalize
                      font-normal
                      mb-2
                      text-darkgreen
                    "
                    v-for="docs in documentsList"
                    :key="docs.id"
                  >
                    <span class="flex mr-1.5">
                      <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.1665 0.833008C1.3395 0.833008 0.666504 1.50601 0.666504 2.33301V12.6663C0.666504 13.4933 1.3395 14.1663 2.1665 14.1663H9.83317C10.6602 14.1663 11.3332 13.4933 11.3332 12.6663V6.16634H7.49984C6.67284 6.16634 5.99984 5.49334 5.99984 4.66634V0.833008H2.1665ZM6.99984 1.12598V4.66634C6.99984 4.94201 7.22417 5.16634 7.49984 5.16634H11.0402L6.99984 1.12598ZM3.83317 7.83301H8.1665C8.4425 7.83301 8.6665 8.05701 8.6665 8.33301C8.6665 8.60901 8.4425 8.83301 8.1665 8.83301H3.83317C3.55717 8.83301 3.33317 8.60901 3.33317 8.33301C3.33317 8.05701 3.55717 7.83301 3.83317 7.83301ZM3.82992 10.1663H6.82861C7.10461 10.1663 7.32861 10.39 7.32861 10.6663C7.32895 10.9193 7.14097 11.1288 6.89697 11.1618L6.82926 11.1663H3.83057C3.55457 11.1663 3.33057 10.9423 3.33057 10.6663C3.33057 10.4133 3.51821 10.2039 3.76221 10.1709L3.82992 10.1663Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </span>
                    <span class="documentfilecolor"
                      >{{ docs.description }}
                    </span>
                   
                  </label>
                
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relative block accordian-list-block">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
              tab
            "
          >
            <div class="card tab">
              <input
                id="tab-single3"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs3"
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  mb-0
                  pt-3
                  pb-3
                  pl-4
                  pr-4
                  top-block
                  bg-darkgreen
                  rounded-t-lg
                  tab
                  w-full
                "
                for="tab-single3"
              >
                <span
                  class="block relative text-sm font-bold capitalize text-white"
                >
                  {{ $t("pages.common.buttons.dis121") }}
                </span>
                <span class="flex transform rotate-180 duration-100">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 16 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </label>
              <div class="tab-content overflow-hidden card-body">
                <div class="block relative pl-4 pr-4 pt-2 pb-5">
                  <div class="flex align-start justify-start">
                    <div class="block relative w-11 h-11 rounded-full">
                      <img
                        src="./../../assets/images/fam-profile.png"
                        alt=""
                        class="w-full h-full rounded-full"
                      />
                    </div>
                    <div class="block relative pl-4">
                      <label
                        class="
                          flex flex-wrap
                          text-sm text-darkblack
                          capitalize
                          font-bold
                          mb-1.5
                          text-darkgray1
                        "
                      >
                        Mateusz Walas
                        <span class="font-normal">
                          {{ $t("pages.common.buttons.dis122") }}
                        </span>
                      </label>

                      <label
                        class="
                          flex
                          align-center
                          justify-start
                          text-sm
                          capitalize
                          font-normal
                          mb-2
                          text-darkgreen
                        "
                      >
                        <span class="flex mr-1.5">
                          <svg
                            class="w-4 h-4"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.95717 2.30161L0.978577 2.28823L3.68461 0.955078L6.60533 4.84936L5.26158 6.64114C5.30179 7.31687 5.58834 7.9544 6.067 8.43305C6.54566 8.9117 7.1832 9.19825 7.85892 9.23845L9.65067 7.8947L13.5449 10.8154L12.2229 13.4988L12.2117 13.5214L12.1983 13.5428C12.1278 13.6565 12.0293 13.7502 11.9123 13.8151C11.7953 13.8799 11.6636 13.9138 11.5298 13.9133H10.8315C9.48617 13.9133 8.15396 13.6483 6.911 13.1335C5.66803 12.6186 4.53864 11.864 3.58731 10.9127C2.63599 9.96133 1.88136 8.83194 1.36651 7.58898C0.851656 6.34601 0.586666 5.0138 0.58667 3.66842V2.97014C0.586242 2.83635 0.620065 2.70468 0.684917 2.58766C0.749771 2.47064 0.843495 2.37216 0.95717 2.30161ZM1.58667 3.66842C1.58667 8.76608 5.73392 12.9133 10.8315 12.9133H11.3965L12.2811 11.1176L9.65048 9.14464L8.18589 10.243H8.01923C7.0217 10.2419 6.06534 9.84517 5.35998 9.1398C4.65461 8.43444 4.25785 7.47808 4.25673 6.48055V6.31389L5.35514 4.84933L3.38239 2.21886L1.58667 3.10358V3.66842Z"
                              fill="#63B15B"
                            />
                          </svg>
                        </span>
                        71 584 652
                      </label>

                      <label
                        class="
                          flex
                          align-center
                          justify-start
                          text-sm
                          capitalize
                          font-normal
                          mb-2
                          text-darkgreen
                        "
                      >
                        <span class="flex mr-1.5">
                          <svg
                            class="w-4 h-4"
                            viewBox="0 0 14 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.4998 0.166992C12.6905 0.166992 13.6665 1.14301 13.6665 2.33366V8.66699C13.6665 9.85764 12.6905 10.8337 11.4998 10.8337H2.49984C1.30919 10.8337 0.33317 9.85764 0.33317 8.66699V2.33366C0.33317 1.14301 1.30919 0.166992 2.49984 0.166992H11.4998ZM11.4998 1.16699H2.49984C1.84982 1.16699 1.33317 1.68364 1.33317 2.33366V2.70215L6.99984 5.7653L12.6665 2.70215V2.33366C12.6665 1.68364 12.1499 1.16699 11.4998 1.16699ZM12.6665 3.83887L7.23747 6.77376C7.16447 6.81319 7.0828 6.83383 6.99984 6.83383C6.91687 6.83383 6.83521 6.81319 6.76221 6.77376L1.33317 3.83887V8.66699C1.33317 9.31701 1.84982 9.83366 2.49984 9.83366H11.4998C12.1499 9.83366 12.6665 9.31701 12.6665 8.66699V3.83887Z"
                              fill="#63B15B"
                            />
                          </svg>
                        </span>
                        mateusz.walas@gmail.com
                      </label>

                      <label
                        class="
                          flex
                          align-center
                          justify-start
                          text-sm
                          capitalize
                          font-normal
                          mb-0
                          text-darkgray1
                        "
                      >
                        <span class="flex mr-1.5">
                          <svg
                            class="w-4 h-4"
                            viewBox="0 0 14 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.99984 0.833008C10.6758 0.833008 13.6665 3.8237 13.6665 7.49967C13.6665 11.1757 10.6758 14.1663 6.99984 14.1663C3.32386 14.1663 0.33317 11.1757 0.33317 7.49967C0.33317 3.8237 3.32386 0.833008 6.99984 0.833008ZM6.99984 1.83301C3.8643 1.83301 1.33317 4.36414 1.33317 7.49967C1.33317 10.6352 3.8643 13.1663 6.99984 13.1663C10.1354 13.1663 12.6665 10.6352 12.6665 7.49967C12.6665 4.36414 10.1354 1.83301 6.99984 1.83301ZM7.17432 3.49251C7.30681 3.49458 7.43307 3.54916 7.52535 3.64425C7.61764 3.73934 7.6684 3.86718 7.6665 3.99967V7.99967C7.66649 8.13228 7.61381 8.25945 7.52004 8.35321C7.42628 8.44698 7.29911 8.49966 7.1665 8.49967H4.49984C4.43358 8.50061 4.3678 8.48837 4.30631 8.46366C4.24483 8.43896 4.18887 8.40228 4.14169 8.35575C4.0945 8.30923 4.05703 8.2538 4.03146 8.19267C4.00589 8.13154 3.99272 8.06594 3.99272 7.99967C3.99272 7.93341 4.00589 7.86781 4.03146 7.80668C4.05703 7.74555 4.0945 7.69012 4.14169 7.64359C4.18887 7.59707 4.24483 7.56039 4.30631 7.53569C4.3678 7.51098 4.43358 7.49874 4.49984 7.49967H6.6665V3.99967C6.66554 3.93275 6.67803 3.86632 6.70322 3.80431C6.7284 3.7423 6.76578 3.68598 6.81314 3.63869C6.8605 3.59139 6.91687 3.55408 6.97891 3.52898C7.04095 3.50387 7.1074 3.49147 7.17432 3.49251Z"
                              fill="#63B15B"
                            />
                          </svg>
                        </span>
                        {{ $t("pages.common.buttons.dis5") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "CurrentFamily",
  data() {
    return {
      documentsList: [],
      readMore: {},
      currentDate: ''
    };
  },
  computed: {
    ...mapGetters("application", {
      details: "selected",
    }),
  },
  created() {
    this.$store.dispatch("user/fetchProfile").then((res) => {
      this.documentsList = res.references;
      this.currentDate = moment(this.details.arrival_information.date,'YYYY-MM-DD').format("DD.MM.YYYY")
  
      
    });
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
};
</script>

<style scoped>
/* Tab content - closed */
.tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}

.tab input:checked ~ .tab-content {
  max-height: 100vh;
}
.tab input:checked + label {
  display: flex;
}
.tab input:checked + label span.flex.transform.rotate-180 {
  transform: rotate(0deg) !important;
}
.tab label::after {
  float: right;
  right: 0;
  top: 0;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  -webkit-transition: all 0.35s;
  -o-transition: all 0.35s;
  transition: all 0.35s;
  display: none;
}
.tab input[type="checkbox"] + label::after {
  content: "+";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
}
.tab input[type="radio"] + label::after {
  content: "\25BE";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
  display: none;
}

.tab input[type="checkbox"]:checked + label::after {
  transform: rotate(315deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label::after {
  transform: rotateX(180deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label .iconbox {
  transform: rotate(180deg);
}
</style>
